import { ReactElement } from 'react'
import { useParams } from 'react-router-dom'
import invariant from 'tiny-invariant'
import { Spin } from 'antd'

import { AdHocParticipationProviders } from '../common/AdHocParticipation/AdHocParticipationProviders'
import { ParticipationInvalidResult } from '../common/ParticipationInvalidResult'
import { AdHocParticipation } from '../common/AdHocParticipation'
import { useResolvedParticipationSessionId } from '../../hooks/useResolvedParticipationSessionId'

export function AdHocParticipationPage(): ReactElement {
  const { accountCommonId, decisionId, participationSessionId: idOrSlug } = useParams<
    'accountCommonId' | 'decisionId' | 'participationSessionId'
  >()

  invariant(accountCommonId, 'accountCommonId required in URL parameters')
  invariant(decisionId, 'decisionId required in URL parameters')
  invariant(idOrSlug, 'participationSessionId required in URL parameters')

  // The route param may be a short slug; resolve it to a participation-session id first.
  const { participationSessionId, loading, notFound } = useResolvedParticipationSessionId(decisionId, idOrSlug)

  if (loading) return <Spin size="large" style={{ display: 'block', margin: '80px auto' }} />
  if (notFound || !participationSessionId) {
    return (
      <ParticipationInvalidResult subTitle="The link may have been replaced with a new one. Please ask the facilitator for the current link." />
    )
  }

  return (
    <AdHocParticipationProviders
      accountCommonId={accountCommonId}
      decisionId={decisionId}
      participationSessionId={participationSessionId}
      linkId={idOrSlug}
    >
      <AdHocParticipation participationSessionId={participationSessionId} />
    </AdHocParticipationProviders>
  )
}
